export function formatCurrency (value) {
    const number = Number(value);
    if (isNaN(number)) {
        throw new Error('Invalid number format');
    }
    return number.toFixed(2);
}
